const fillServerErrors = require('../../olycommon/servererrorfiller');

class ForgotPasswordController {
    constructor(resetPasswordService, settingsService) {
        this.resetPasswordService = resetPasswordService;
        this.settings = settingsService.settings;
    }

    sendResetRequest() {
        fillServerErrors.clearForm(this.forgotPasswordForm, this);

        if (!this.forgotPasswordForm.$valid) {
            // don't submit to server if client side is not valid
            this.hasSubmittedForm = false;
            return;
        }

        this.resetPasswordService.forgotPassword(this.emailInput);

        this.hasSubmittedForm = true;
    }

}

const forgotPasswordComponentDefinition = {
    controller: ['ResetPasswordService', 'SettingsService', ForgotPasswordController],
    template: require('./forgot-password.component.html').trim(),
};

module.exports = {
    ForgotPasswordController,
    forgotPasswordComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/auth/forgotpassword/forgot-password.component.js